import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import {
  getDiets,
  getHousingTypes,
  getCareTyping,
  getCookingForms,
  updateDepartment,
  getLocations,
  getDepartments,
  getDepartmentById,
  createDepartment, deleteLocationById, deleteDepartmentById,
} from '../../services';
import { Modal, MultiSelect } from '../../components';

const DepartmentCreate = (props) => {
  // const newDepartment = () => {
  //   createDepartment(
  //     location,
  //     name,
  //     housingType,
  //     careTyping,
  //     cookingForm,
  //     patientsAmount,
  //     patientsDietAmount,
  //     VSE
  //   );
  //   setCookingForm("");
  //   setPatientsAmount("");
  //   setPatientsDietAmount("");
  //   setName("");
  //   setCareTyping("");
  //   setHousingType("");
  //   setLocation("");
  //   document.getElementById("selectbox__housing_type").selectedIndex = 0;
  //   document.getElementById("selectbox__location").selectedIndex = 0;
  // };

  const [patientsAmount, setPatientsAmount] = useState();
  const [patientsDietAmount, setPatientsDietAmount] = useState();
  const [name, setName] = useState();
  const [housingType, setHousingType] = useState();
  const [careTyping, setCareTyping] = useState();
  const [location, setLocation] = useState();
  const [department, setDepartment] = useState();
  const [cookingForm, setCookingForm] = useState();
  const [VSE, setVSE] = useState();
  const [diets, setDiets] = useState();
  const [newDepartment, setNewDepartment] = useState(false);
  const [deleteDepartmentId, setDeleteDepartmentId] = useState();

  // Lists from database
  const [dietArray, setDietArray] = useState();
  const [housingTypeArray, setHousingTypeArray] = useState();
  const [locationArray, setLocationArray] = useState();
  const [departmentArray, setDepartmentArray] = useState();
  const [careTypingArray, setCareTypingArray] = useState();
  const [cookingFormArray, setCookingFormArray] = useState();

  const openModal = (departmentId) => {
    document.querySelector('.overlay').classList.toggle('modal__active');
    setDeleteDepartmentId(departmentId)
  }

  const deleteDepartment = () => {
    deleteDepartmentById(deleteDepartmentId).then(() => {
      document.querySelector('.overlay').classList.toggle('modal__active');
      setDeleteDepartmentId(null);
      setDepartment(null);
      getDepartments(location).then(list => {
        setDepartmentArray(list)
      })
    })
  }

  const resetForm = () => {
    setName("")
    setPatientsAmount("")
    setPatientsDietAmount("")
    setVSE("")
    setHousingType("")
    setCareTyping("")
    setCookingForm("")
  }

  useEffect(() => {
    // Diets will not be implemented in MVP
    // getDiets().then(list => {
    //   setDietArray(list);
    // })
    getLocations(props.customerId).then((list) => {
      setLocationArray(list);
    });

    getHousingTypes().then((list) => {
      setHousingTypeArray(list);
    });
    getCareTyping().then((list) => {
      setCareTypingArray(list);
    });
    getCookingForms().then((list) => {
      setCookingFormArray(list);
    });
  }, []);


  useEffect(()=>{
    if(location > 0) {
      getDepartments(location).then(list => {
        setDepartmentArray(list)
      })
    }
    setDepartment(0)
  }, [location])

  useEffect(() => {
    if(department > 0) {
      getDepartmentById(department).then(list => {
          setName(list.name)
          setPatientsAmount(list.amount_of_patients)
          setPatientsDietAmount(list.amount_of_dietpatients)
          setVSE(list.standard_vse)
          setHousingType(list.housing_type_id)
          setCareTyping(list.care_types)
          setCookingForm(list.cooking_forms)
      })
    }
    else {
      resetForm();
    }
  }, [department])

  const submitDepartment = () => {
    if(!newDepartment) {
      updateDepartment(
        department,
        name,
        housingType,
        careTyping,
        cookingForm,
        patientsAmount,
        patientsDietAmount,
        VSE
      ).then(() => props.next());
    }
    else {
      createDepartment(
        location,
        name,
        housingType,
        careTyping,
        cookingForm,
        patientsAmount,
        patientsDietAmount,
        VSE
      ).then(() => {
        setNewDepartment(false);
        setDepartment(0);
        resetForm();
        if (location > 0) {
          getDepartments(location).then(list => {
            setDepartmentArray(list)
          })
        }
      });
    }
  };

  return (<>
    <Modal header="Weet je zeker dat je deze afdeling wilt verwijderen?">
      <button onClick={deleteDepartment} className="button__delete">Verwijderen</button>
    </Modal>
    <div className="form__container__content">
      <div className="form__container__content__category">
        <span>Selecteer een afdeling</span>
      </div>
      <div className="form__fields">
        <div className="form__fields__field">
          <span className="form__fields__field__label">Locatie</span>
          <select
            required="true"
            value={location}
            id="selectbox__location"
            onChange={(e) => setLocation(e.target.value)}
            className="form__fields__field__input"
          >
            <option value="0">Selecteer een locatie</option>
            {locationArray}
          </select>
        </div>
        {location &&
        <div className="row w-50">
          <div className="form__fields__field w-100">
            <span className="form__fields__field__label">Afdeling</span>
            <select
                required="true"
                value={department}
                id="selectbox__location"
                onChange={(e) => setDepartment(e.target.value)}
                className="form__fields__field__input"
            >
              <option value="0">Selecteer een afdeling</option>
              {departmentArray}
            </select>
          </div>
          <button
              className="form__container__add__button"
              onClick={() => setNewDepartment(true)}
          >
            <i className="fas fa-plus"></i>
          </button>
        </div>
      }
      </div>
      {(department > 0 || newDepartment) &&
      <div className="form__container__content__category">
        <span>Afdelingsgegevens</span>
      </div>}
      {(department > 0 || newDepartment) &&
        <div className="form__fields">
          <div className="form__fields__field">
            <span className="form__fields__field__label">Afdelingsnaam</span>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Aantal dieet</span>
            <input
              value={patientsDietAmount}
              onChange={(e) => setPatientsDietAmount(e.target.value)}
              type="text"
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">
              Aantal zorgbehoevende
            </span>
            <input
              value={patientsAmount}
              onChange={(e) => setPatientsAmount(e.target.value)}
              type="text"
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">
              Standaard verstrekkingseenheid in grammen
            </span>
            <input
              // required="true"
              value={VSE}
              onChange={(e) => setVSE(e.target.value)}
              type="text"
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Zorgtypering</span>
            <MultiSelect
              array={careTypingArray}
              value={careTyping}
              update={setCareTyping}
              label="Selecteer een zorgtypering"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Woonvorm</span>
            <select
              required="true"
              value={housingType}
              id="selectbox__housing_type"
              onChange={(e) => setHousingType(e.target.value)}
              className="form__fields__field__input"
            >
              <option>Selecteer een woonvorm</option>
              {housingTypeArray}
            </select>
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Kookvorm</span>
            <MultiSelect
              array={cookingFormArray}
              value={cookingForm}
              update={setCookingForm}
              label="Selecteer een kookvorm"
            />
          </div>
          <>
            <button
              className="form__container__content__button"
              onClick={() => submitDepartment()}
              >
              OPSLAAN <i className="fas fa-arrow-right"></i>
            </button>
            <button onClick={() => openModal(department)} className="form__container__content__button btn-danger">Verwijderen</button>
          </>
        </div>}
    </div>
    </>
  );
};

export default DepartmentCreate;
